import { UseMutationResult, useMutation } from 'react-query'
import axios from 'axios'

type VariablesType = {
  signedRequest: string
  file: File
}

export const useUploadFileToSignedLink = (): UseMutationResult<
  unknown,
  unknown,
  VariablesType,
  unknown
> => {
  return useMutation(({ signedRequest, file }: VariablesType) =>
    axios.put(signedRequest, file),
  )
}
